module.exports = __webpack_public_path__ + "static/img/172178848836586479149910.766dc6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/picture/20240724/172178848836586479149910.png
// module id = JUxi
// module chunks = 7